import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { GET_INTENT_PROJECT_CONFIG } from "./gql";

const useIntentProjectConfig = (intentProjectId: string) => {
  const { data, loading, error } = useQuery(GET_INTENT_PROJECT_CONFIG, {
    variables: { id: intentProjectId },
    skip: !intentProjectId,
  });

  const configElements = useMemo(
    () => data?.intentProject?.configElements || [],
    [data?.intentProject?.configElements]
  );
  
  return {
    configElements,
    loading,
    error,
  };
};

export default useIntentProjectConfig;
